$( document ).ready(function() {
  
  // TRIGGER ADD TO CART
  $(document).on("click", ".product-form__buttons button.product-form__submit", function(){
    setShippingText();
  });

  // TRIGGER CART QUANTITY
  $(document).on("click", "button.quantity__button", function(){
    setShippingText();
  });

  // FIX ADD CART LAYOUT
  if ($('.product-form__quantity').length) {
    if ($('.product-form__quantity').css('display') === 'none') {
      console.log('left');
      $('.custom-cart-checkout-box').css('padding-left', '0');
      $('.desc-line.time').addClass('full-width');
      $('.desc-line.delivery').addClass('full-width');
      $('.desc-line.product-desc-shipping-text').addClass('full-width');
    }
  }
});





function setShippingText(){
  
  setTimeout(function() { 
    var cartTotal = $('div#mini-cart-subtotal').text();
    var cartTotalParse = cartTotal.replace(/€|EUR/g, '').replace(',', '.').trim();
  
    if (cartTotalParse >= 99) {
      if (window.location.href.includes("/en/")) {
        $(".desc-line.product-desc-shipping-text").text('Free shipping');        
      }
      else {
        $(".desc-line.product-desc-shipping-text span").text('Kostenloser Versand');        
      }
    }
    else {
      var restShipping = 99 - cartTotalParse;
      var restShippingF = parseFloat(restShipping);
      var restShippingTotal = restShippingF.toFixed(2);
  
      if (window.location.href.includes("/en/")) {
        $(".desc-line.product-desc-shipping-text").text('Only €' + restShippingTotal + ' until free shipping');
      }
      else {
        $(".desc-line.product-desc-shipping-text").text('Nur noch €' + restShippingTotal + ' bis zum kostenlosen Versand');
      }
    }
  }, 1500);
}




